<template>
  <div class="table-responsive">
    <table class="table trade-details-table">
      <tbody>
        <tr>
          <td :class="smallTextClass">{{ labels.status }}</td>
          <td class="prop-value trade-status-filled" :class="smallTextClass">{{ tradeStatus }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.tradeId }}</td>
          <td class="prop-value" :class="smallTextClass">{{ tradeIdentifier }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.orderId }}</td>
          <td class="prop-value" :class="smallTextClass">#{{ trade?.oid }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.timestamp }}</td>
          <td class="prop-value" :class="smallTextClass">{{ dateResolver(trade?.ts) }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.type }}</td>
          <td class="prop-value" :class="smallTextClass">{{ orderTypeResolver(trade?.tt) }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.orderType }}</td>
          <td class="prop-value" :class="smallTextClass">{{ orderForTrade?.data?.type }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.code }}</td>
          <td class="prop-value" :class="smallTextClass">{{ trade?.sc }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.name }}</td>
          <td v-if="isBulgarian" class="prop-value" :class="smallTextClass">{{ trade?.nBG ? trade?.nBG : trade?.nEN }}</td>
          <td v-if="isEnglish" class="prop-value" :class="smallTextClass">{{ trade?.nEN }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.exchange }}</td>
          <td class="prop-value" :class="smallTextClass">{{ trade?.xc || trade?.ex }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.instrumentType }}</td>
          <td class="prop-value" :class="smallTextClass">{{ instrumentTypeLabel }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ quantityOrFaceValueLabel }}</td>
          <td class="prop-value" :class="smallTextClass">{{ trade?.qty }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.price }}</td>
          <td v-if="isBondTrade" class="prop-value" :class="smallTextClass">{{ formatPrice(trade?.sp, '%').replace(' ', '&nbsp;') }}</td>
          <td v-else class="prop-value" :class="smallTextClass">{{ formatPrice(trade?.sp, trade?.cc).replace(' ', '&nbsp;') }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.fee }}</td>
          <td class="prop-value" :class="smallTextClass">{{ formatPrice(trade?.fee, trade?.cc).replace(' ', '&nbsp;') }}</td>
        </tr>
        <tr v-if="isBuyTrade">
          <td :class="smallTextClass">{{ labels.totalAmount }}</td>
          <td class="prop-value" :class="smallTextClass">{{ formatPrice(tradeTotalAmountResolver(trade) + trade?.fee, trade?.cc).replace(' ', '&nbsp;') }}</td>
        </tr>
        <tr v-else>
          <td :class="smallTextClass">{{ labels.totalAmount }}</td>
          <td class="prop-value" :class="smallTextClass">{{ formatPrice(tradeTotalAmountResolver(trade) - trade?.fee, trade?.cc).replace(' ', '&nbsp;') }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    trade: { type: Object, default: null },
    tradeListOrders: { type: Array, required: true },
    windowWidth: { type: Number, required: true },
    userLanguage: { type: String, required: true },
    labels: { type: Object, required: true },
    dateResolver: { type: Function, required: true },
    orderTypeResolver: { type: Function, required: true },
    tradeTotalAmountResolver: { type: Function, required: true },
    formatPrice: { type: Function, required: true }
  },
  computed: {
    smallTextClass() {
      return { 'xsmall-font-size': 1200 > this.windowWidth };
    },
    isBulgarian() {
      return 0 === 'BG'.localeCompare(this.userLanguage);
    },
    isEnglish() {
      return 0 === 'EN'.localeCompare(this.userLanguage);
    },
    orderForTrade() {
      return this.tradeListOrders.filter(item => {
        return 0 === this.trade?.oid.localeCompare(item.oid);
      })[0];
    },
    isBondTrade() {
      return Number.parseInt(this.trade?.stid, 10) === 2;
    },
    isBuyTrade() {
      return 0 === 'b'.localeCompare(this.trade?.tt);
    },
    instrumentTypeLabel() {
      const stockType = Number.parseInt(this.trade?.stid, 10);
      switch (stockType) {
        case 1:
        case 4:
          return this.labels.stocksAndEtfs;
        case 2:
        case 7:
        case 8:
          return this.labels.bonds;
        case 5:
          return this.labels.reits;
        default:
          return this.labels.other;
      }
    },
    quantityOrFaceValueLabel() {
      return this.isBondTrade ? this.labels.faceValue : this.labels.numberOfShares;
    },
    tradeIdentifier() {
      const value = this.trade?.trid
        ?? this.trade?.tid
        ?? this.trade?.trade_id
        ?? this.trade?.id;
      return value == null ? "" : value.toString();
    },
    tradeStatus() {
      if (!this.trade) {
        return "";
      }

      const status = Number.parseInt(this.trade?.sts ?? this.trade?.status, 10);
      if (Number.isNaN(status)) {
        return this.labels.filled;
      }

      return 5 === status ? this.labels.filled : "";
    }
  }
};
</script>

<style scoped>
.prop-value {
  text-align: right;
  font-weight: bold;
}

.trade-details-table td {
  font-size: 1rem;
  line-height: 1.35;
  padding: 0.6rem 0.5rem;
}

.xsmall-font-size {
  font-size: 1rem;
}

.trade-status-filled {
  color: #008000;
}
</style>
